import { useEffect, useState } from 'react';

import { prepareGenesysScript } from '../utils';
import { purgeLocalStorage } from '../utils/purgeLocalStorage';
import { useGetWebMessengerConfiguration } from './useGetWebMessengerConfiguration';

export const useLoadClient = () => {
  const { data } = useGetWebMessengerConfiguration();
  const [clientLoaded, setClientLoaded] = useState(false);
  const { deploymentId, environment, scriptUrl } = data ?? {};

  useEffect(() => {
    window.addEventListener('beforeunload', purgeLocalStorage);

    return () => {
      window.removeEventListener('beforeunload', purgeLocalStorage);
    };
  }, []);

  useEffect(() => {
    const onLoad = () => setClientLoaded(true);
    const script = prepareGenesysScript({
      deploymentId,
      environment,
      scriptUrl,
    });
    if (script) {
      script.addEventListener('load', onLoad);
      document.head.append(script);

      return () => script.remove();
    }

    return undefined;
  }, [deploymentId, environment, scriptUrl]);

  return { clientLoaded };
};
